<template>
  <div>
    <div>
      <NavBar :isShowLeft="false">
        <template slot="left">
          <van-icon name="arrow-left" @click="handleBack" />
        </template>
      </NavBar>
    </div>
    <Loading :loading="loading">
      <div class="center">
        <div class="pic">
          <img src="./img/success.png" alt="" />
        </div>
        <div class="submit-text">您已成功提交投保信息!</div>
        <div class="submit-button share_button" @click="shareSignLinkClick()">分享客户告知书</div>
        <div class="submit-button" @click="handleClick()">查看订单</div>
      </div>
    </Loading>
    <ShareWx ref="shareWx" @handleShare="handleShare" />
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import NavBar from '@/components/h5header'
import ShareWx from '@/components/ShareWx'
import weixinShare from '@/services/h5/app-api/weixinShare.js'
// import { isWeChatBrowser } from '@/config/h5/index.js'
import appBackMainPage from '@/services/h5/app-api/appBackMainPage.js'
// import appBackLastPage from '@/services/h5/app-api/appBackLastPage.js'
import { isApp } from '@/utils/platform'
import API from '@/services/h5/my'
import Loading from '@/components/data-loading'
import Clipboard from 'clipboard'

export default {
  data() {
    return {
      data: 'sdsdf',
      swipeFlag:false,
      loading: false,
      contractId: null,
      shareData: {}
    }
  },
  created() {
    this.loading = true
    console.log("查询参数", this.$route.params)
    let params = {
      contractId: this.$route.params.contractId
    }
    API.orderDetail(params).then(res => {
      if (res.data && res.data.code === 1000) {
        this.shareData.linkUrl = res.data.data.customerNotifyUrl
        this.shareData.logoUrl = res.data.data.policyStatusImgUrl
      }
      this.loading = false
    })
  },
  components: {
    NavBar,
    ShareWx,
    Loading,
  },
  // computed: {
  //   ...mapState('product', ['contractId'])
  // },
  methods: {
    handleClick() {
      // this.$router.push({ path: `/baodan/${this.$route.params.contractId}` })
      this.swipeFlag = true
      this.$router.push({ path: '/myorder'})
    },
    handleBack() {
      console.log('页面销毁')
      let path = localStorage.getItem('successBack')
      if (!isApp || path !== '/product?active=N') {
        this.$router.push(path)
      } else {
        path == '/product?active=N' && appBackMainPage({ pageIndex: '1' })
      }
    },
    handleShare(val) {
      weixinShare({
        shareType: val,
        titleName: "客户告知书",
        describe: "上海万利保险经纪有限公司客户告知书",
        imageUrl: this.shareData.logoUrl,
        shareUrl: this.shareData.linkUrl
      })
    },
    shareSignLinkClick() {
      if (isApp) {
        this.$refs.shareWx.show = true
      } else {
        this.copyActiveCode()
      }
    },
    copyActiveCode() {
      let that = this
      const clipboard = new Clipboard('.share_button', {
        text: () => {
          return that.shareData.linkUrl
        }
      })
      clipboard.on('success', function (e) {
        e.clearSelection()
        that.$toast('复制成功')
      })
    },
  },
  beforeDestroy() {
    if(this.swipeFlag) {
      this.handleClick()
    }else {
      this.handleBack()
    }
  },
}
</script>
<style scoped lang="less">
.center {
  width: 375px;
}
.pic {
  width: 93px;
  height: 93px;
  margin: 0 auto;
  margin-top: 147px;
}
.pic img {
  width: 100%;
}
.submit-text {
  width: 375px;
  font-size: 18px;
  color: #333;
  text-align: center;
  margin-top: 15px;
}
.submit-button {
  font-size: 18px;
  width: 150px;
  height: 35px;
  line-height: 35px;
  border-radius: 4px;
  border: 1px solid @c-color-primary;
  color: @c-color-primary;
  text-align: center;
  margin: 0 auto;
  margin-top: 15px;
}
</style>
